// do not remove. This page for redirect to SIGN-UP for referrals
export default function Referral() {
  return null;
}
